import { useQuery } from "@tanstack/react-query";
import { fetchVideos } from "../services/videoService";

export const useFetchVideos = () => useQuery({
    queryKey: ['videos'],
    queryFn: fetchVideos
});
